<template>
    <div class="pt-12 w-full text-center">
        <!--                        <a href="#" v-scroll-to="'#download'" class="flex-1 text-center verical-center justify-center text-sm px-6 py-3 leading-none no-underline border rounded-xl bg-main-green text-grey-lightest border-black hover:border-grey-lightest hover:text-grey-lightest hover:bg-transparent mt-4 mt-0 mr-10">
                                    Download
                                </a>-->
        <div class="inline-block">
            <a
                href="https://play.google.com/store/apps/details?id=ai.lingua.vetrov"
                target="_blank"
                class="flex items-center justify-center text-white bg-black rounded-lg py-4 px-6 text-center no-underline"
            >
                <div class="mr-3">
                    <svg viewBox="30 336.7 120.9 129.2" width="30">
                        <path fill="#FFD400"
                              d="M119.2,421.2c15.3-8.4,27-14.8,28-15.3c3.2-1.7,6.5-6.2,0-9.7  c-2.1-1.1-13.4-7.3-28-15.3l-20.1,20.2L119.2,421.2z">
                        </path>
                        <path fill="#FF3333"
                              d="M99.1,401.1l-64.2,64.7c1.5,0.2,3.2-0.2,5.2-1.3  c4.2-2.3,48.8-26.7,79.1-43.3L99.1,401.1L99.1,401.1z">
                        </path>
                        <path fill="#48FF48" d="M99.1,401.1l20.1-20.2c0,0-74.6-40.7-79.1-43.1  c-1.7-1-3.6-1.3-5.3-1L99.1,401.1z">
                        </path>
                        <path fill="#3BCCFF"
                              d="M99.1,401.1l-64.3-64.3c-2.6,0.6-4.8,2.9-4.8,7.6  c0,7.5,0,107.5,0,113.8c0,4.3,1.7,7.4,4.9,7.7L99.1,401.1z">
                        </path>
                    </svg>
                </div>
                <div>
                    <div class="text-xs">
                        УСТАНОВИТЬ ИЗ
                    </div>
                    <div class=" font-sans text-xl font-semibold">
                        Google Play
                    </div>
                </div>
            </a>
        </div>
        <!--                        <span class="flex-2 inline-flex items-center justify-center text-center mt-4">
                                    <img src="./../assets/play-button.svg" alt="play button" class="h-8 mr-2">
                                    <a href="#" class="no-underline text-semibold text-grey-lightest text-lg opacity-50 hover:opacity-100">
                                        <span class="md:text-lg sm:text-md md:block xs:hidden">Watch How it Works</span>
                                    </a>
                                </span>-->
    </div>
<!--    <div id="download" class="pt-12 pb-12 w-full text-center">
        <h1 class="text-main-black font-semibold text-2xl">Установить приложение</h1>
        <div class="mt-4 opacity-50 text-sm md:block xs:hidden">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </div>
        <div>
            <a href="#"> <img src="./../assets/app-store.svg" alt="" class="h-32 mr-6"></a>
            <a href="#"> <img src="./../assets/google-play.svg" alt="" class="h-32"></a>
        </div>
    </div>-->
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>